import { Content } from "src/shared/components/content";

export const Transparency = () => (
  <svg version="1.1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>
      <Content id="cid$#2984765#" />
    </title>
    <defs>
      <circle id="a" cx="100" cy="100" r="100" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-620 -292)">
        <g transform="translate(620 292)">
          <mask id="b" fill="white">
            <use xlinkHref="#a" />
          </mask>
          <use fill="#E8F4D9" xlinkHref="#a" />
          <g mask="url(#b)" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(60 64)" strokeWidth="3.7866">
              <g transform="translate(3.4162)" stroke="#264A19">
                <path
                  id="Path"
                  d="m30.745 15.728v-13.676c-2.733-2.7353-7.5156-2.7353-10.248 0l-5.1243 13.676-5.1242 5.1286-10.248 23.934"
                />
                <path
                  id="Path"
                  d="m40.994 15.728v-13.334c2.7329-2.7352 7.5155-2.7352 10.248 0l5.1243 13.334 5.1242 5.1287 10.248 23.934"
                />
                <path id="Path" d="m22.205 29.404c0-3.7609 6.1491-6.8381 13.665-6.8381s13.665 3.0772 13.665 6.8381" />
                <line id="Path" x1="30.745" x2="30.745" y1="55.047" y2="23.25" />
                <line id="Path" x1="40.994" x2="40.994" y1="55.047" y2="23.25" />
              </g>
              <g transform="translate(0 37.952)" stroke="#8CC63F">
                <path id="Path" d="m6.8323 17.095c0-5.8125 4.441-10.257 10.248-10.257" />
                <path id="Path" d="m51.242 17.095c0-5.8125 4.441-10.257 10.248-10.257" />
                <path
                  id="c"
                  d="m17.081 34.191c9.4334 0 17.081-7.6539 17.081-17.095 0-9.4416-7.6474-17.095-17.081-17.095-9.4335 0-17.081 7.6539-17.081 17.095 0 9.4415 7.6473 17.095 17.081 17.095z"
                />
                <path d="m61.491 34.191c9.4335 0 17.081-7.6539 17.081-17.095 0-9.4416-7.6473-17.095-17.081-17.095-9.4334 0-17.081 7.6539-17.081 17.095 0 9.4415 7.6473 17.095 17.081 17.095z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
